/**
 * Terminal pending state for practice sessions — shown while the
 * end-of-session mutations run, before router.push to the completed page.
 * Neutral ink only (pending is not a celebration — no vermilion).
 */
export function CompletionPending() {
    return (
        <main
            aria-live="polite"
            className="flex min-h-dvh flex-col items-center justify-center bg-paper px-5 text-ink"
        >
            <p className="animate-pulse font-serif text-lg text-muted-fg italic">
                The ledger takes your entry…
            </p>
        </main>
    )
}
